import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { Close } from '@mui/icons-material';

import { BACKGROUND_PRIMARY } from '../../theme';
import { Timeline } from '../../timeline';

const Panel = styled.div`
  width: 100%;
  height: ${({ open }) => (open ? '100%' : 0)};
  max-height: ${({ open }) => (open ? '72px' : 0)};
  background-color: white;
  transition: 0.2s max-height;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  border-top: 1px solid ${BACKGROUND_PRIMARY};
  flex: 1;
`;

const mapState = createSelector(
  ({ bottomPanel }) => bottomPanel,
  ({ timelines }) => timelines,
  (bottomPanel, timelines) => ({
    bottomPanel,
    timelines,
  })
);

export const BottomPanel = () => {
  const { bottomPanel, timelines } = useSelector(mapState);
  const dispatch = useDispatch();
  const close = useCallback(() => {
    dispatch({ type: 'CLEAR_BOTTOM_PANEL' });
    setTimeout(() => window.dispatchEvent(new Event('resize')), 200);
  }, [dispatch]);

  const isOpen = bottomPanel === 'timeline' && Object.values(timelines).length;

  return (
    <Panel open={isOpen}>
      <Close onClick={close} style={{ margin: 16 }}>
        ×
      </Close>
      {bottomPanel === 'timeline' && Object.values(timelines).length ? (
        <Timeline />
      ) : null}
    </Panel>
  );
};
